(() => {

  const sizeKey=value=>value.trim().toUpperCase();
  const sizeInputs=form=>[...form.querySelectorAll('input[type="checkbox"][name="filter.v.option.size"]')];
  const groupSizes=()=>{
    document.querySelectorAll('#CollectionFiltersForm').forEach(form=>{
      const groups=new Map();
      sizeInputs(form).forEach(input=>{
        const key=sizeKey(input.value);
        if(!groups.has(key))groups.set(key,[]);
        groups.get(key).push(input);
      });
      groups.forEach((inputs,key)=>{
        const first=inputs[0];
        const selected=inputs.some(input=>input.checked);
        // Preserve the original values for Shopify's OR filter submission.
        first.checked=selected;
        first.disabled=inputs.every(input=>input.disabled);
        const label=first.closest('li')?.querySelector('label .text');
        if(label&&label.textContent!==key)label.textContent=key;
        first.setAttribute('aria-label',key);
        inputs.slice(1).forEach(input=>{
          const row=input.closest('li');
          if(row){row.hidden=true;row.style.display='none';}
        });
      });
    });

    const selected=new URLSearchParams(location.search).getAll('filter.v.option.size');
    const seen=new WeakMap();
    document.querySelectorAll('a.active-facets__button.js-facet-remove:not(.facets__clear-all)').forEach(link=>{
      const target=new URL(link.href,location.href);
      const remaining=target.searchParams.getAll('filter.v.option.size');
      const removed=selected.filter(value=>!remaining.includes(value));
      if(!removed.length)return;
      const key=sizeKey(removed[0]);
      if(removed.some(value=>sizeKey(value)!==key))return;
      const parent=link.closest('ul') || link.parentElement;
      if(!seen.has(parent))seen.set(parent,new Set());
      const keys=seen.get(parent);
      link.hidden=keys.has(key);
      link.style.display=keys.has(key)?'none':'';
      keys.add(key);
      target.searchParams.delete('filter.v.option.size');
      remaining.filter(value=>sizeKey(value)!==key).forEach(value=>target.searchParams.append('filter.v.option.size',value));
      link.href=target.pathname+target.search;
      const text=link.querySelector('.text');
      if(text&&text.textContent!==key)text.textContent=key;
      link.setAttribute('aria-label','Remove size '+key);
    });
  };
  document.addEventListener('input',event=>{
    const input=event.target;
    if(input.matches?.('#CollectionFiltersForm input[name="filter.v.option.size"]')){
      sizeInputs(input.form).filter(other=>sizeKey(other.value)===sizeKey(input.value)).forEach(other=>{other.checked=input.checked;});
    }
  },true);

  const labelControls = () => {
    document.querySelectorAll('#CollectionFiltersForm input[type="checkbox"]').forEach((input,index) => {
      if (!input.id) input.id = 'PKFilterAccessible-' + index;
      const row = input.closest('li');
      const label = input.parentElement.querySelector('label') || row?.querySelector('label');
      if (label) label.htmlFor = input.id;
      const text = (row?.querySelector('.facet-checkbox__text-label')?.textContent || row?.innerText || label?.textContent || '').replace(/\s+/g,' ').trim();
      if (text && !text.includes('gid://')) input.setAttribute('aria-label',text);
    });
    document.querySelectorAll('input[type="email"]').forEach(input => {
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label',input.labels?.[0]?.textContent.trim() || input.placeholder || 'Email address');
    });
    document.querySelectorAll('#CollectionFiltersForm input[name="filter.v.price.gte"]').forEach(input=>input.setAttribute('aria-label','Minimum price'));
    document.querySelectorAll('#CollectionFiltersForm input[name="filter.v.price.lte"]').forEach(input=>input.setAttribute('aria-label','Maximum price'));
  };
  labelControls();
  groupSizes();
  // Ignore unrelated cart, video and price changes. Only new form/filter
  // content needs the accessibility and duplicate-size normalization pass.
  const relevantSelector = '#CollectionFiltersForm, .active-facets, input[type="email"]';
  let queued = false;
  new MutationObserver(records => {
    const relevant = records.some(record =>
      record.target.nodeType === 1 && record.target.closest('#CollectionFiltersForm, .active-facets') ||
      [...record.addedNodes].some(node => node.nodeType === 1 &&
        (node.matches(relevantSelector) || node.querySelector(relevantSelector)))
    );
    if (!relevant || queued) return;
    queued = true;
    setTimeout(() => { queued = false; labelControls(); groupSizes(); }, 0);
  }).observe(document.body,{childList:true,subtree:true});

  const sidebar=document.getElementById('halo-sidebar');
  if(sidebar && sidebar.querySelector('#CollectionFiltersForm')){
    let filterOpen=false,filterReturn=null;
    const triggers=[...document.querySelectorAll('[data-sidebar]')];
    triggers.forEach(trigger=>{
      trigger.setAttribute('role','button');
      trigger.setAttribute('tabindex','0');
      trigger.setAttribute('aria-label','Filter products');
      trigger.setAttribute('aria-controls','halo-sidebar');
      trigger.addEventListener('keydown',event=>{
        if(event.key==='Enter'||event.key===' '){event.preventDefault();trigger.click();}
      });
    });
    const syncFilters=()=>{
      const drawer=getComputedStyle(sidebar).position==='fixed';
      const next=drawer && document.body.classList.contains('open-mobile-sidebar');
      if(filterOpen&&!next&&filterReturn?.isConnected)filterReturn.focus();
      sidebar.inert=drawer&&!next;
      sidebar.setAttribute('aria-hidden',String(drawer&&!next));
      triggers.forEach(trigger=>trigger.setAttribute('aria-expanded',String(next)));
      if(drawer){sidebar.setAttribute('role','dialog');sidebar.setAttribute('aria-label','Product filters');sidebar.setAttribute('aria-modal',String(next));}
      else{sidebar.removeAttribute('role');sidebar.removeAttribute('aria-modal');}
      if(next&&!filterOpen){
        filterReturn=document.activeElement;
        setTimeout(()=>{if(filterOpen)sidebar.querySelector('[data-close-sidebar]')?.focus();},350);
      }
      filterOpen=next;
    };
    syncFilters();
    new MutationObserver(syncFilters).observe(document.body,{attributes:true,attributeFilter:['class']});
    window.addEventListener('resize',syncFilters);
    document.addEventListener('keydown',event=>{
      if(!filterOpen)return;
      if(event.key==='Escape'){event.preventDefault();sidebar.querySelector('[data-close-sidebar]')?.click();}
      if(event.key==='Tab'){
        const items=[...sidebar.querySelectorAll('button,a[href],input,select,textarea,summary,[tabindex="0"]')].filter(e=>!e.disabled&&e.getClientRects().length&&getComputedStyle(e).visibility!=='hidden');
        const first=items[0],last=items[items.length-1];
        if(!first)return;
        if(event.shiftKey&&(document.activeElement===first||!sidebar.contains(document.activeElement))){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&(document.activeElement===last||!sidebar.contains(document.activeElement))){event.preventDefault();first.focus();}
      }
    });
  }

  const guide=document.getElementById('halo-size-chart-popup');
  if (!guide) return;
  guide.setAttribute('role','dialog');
  guide.setAttribute('aria-modal','true');
  guide.setAttribute('aria-label','Size guide and measurements');
  let open=false,returnTo=null;
  const sync=()=>{
    const next=document.body.classList.contains('size-chart-show');
    if(next===open)return;
    open=next;
    guide.setAttribute('aria-hidden',String(!open));
    if(open){
      returnTo=document.activeElement;
      setTimeout(()=>{if(open)guide.querySelector('[data-close-size-chart-popup]')?.focus();},500);
    }else if(returnTo?.isConnected){returnTo.focus();}
  };
  guide.setAttribute('aria-hidden','true');
  new MutationObserver(sync).observe(document.body,{attributes:true,attributeFilter:['class']});
  guide.addEventListener('transitionend',()=>{if(open&&!guide.contains(document.activeElement))guide.querySelector('[data-close-size-chart-popup]')?.focus();});
  document.addEventListener('focusin',event=>{if(open&&!guide.contains(event.target))guide.querySelector('[data-close-size-chart-popup]')?.focus();});
  document.addEventListener('keydown',event=>{
    if(!open)return;
    if(event.key==='Escape'){
      event.preventDefault();event.stopImmediatePropagation();
      guide.querySelector('[data-close-size-chart-popup]')?.click();
    }else if(event.key==='Tab'){
      const controls=[...guide.querySelectorAll('button,a[href],input,select,textarea,summary,[tabindex="0"]')].filter(e=>!e.disabled&&e.getClientRects().length);
      const first=controls[0],last=controls[controls.length-1];
      if(!first)return;
      if(event.shiftKey&&(document.activeElement===first||!guide.contains(document.activeElement))){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&(document.activeElement===last||!guide.contains(document.activeElement))){event.preventDefault();first.focus();}
    }
  },true);
})();
